export const environment = {
  production: true,
  guiBackendRootEndpoint: "https://prbe.predict.hu:8080/gui-backend",
  plotsRootPath: "assets/storage/tst/plots"
};
